<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>Olá! Vamos começar sua autoavaliação técnica?</h2>
    </div>

    <div>
      <h2>Analise as suas responsabilidades</h2>
      <p>
        As responsabilidades que aparecerão na sua tela foram consolidadas
        na etapa “Mapeamento Técnico”. Ao lado de cada responsabilidade,
        aparecerá uma escala que vai de
        <span class="info--text">"Não executou"</span> a
        <span class="info--text">"Excelente"</span>.
      </p>
      <p>
        Lembre-se que compete ao gestor todas as responsabilidades da unidade.
      </p>
    </div>

    <div>
      <h2>Analise a forma de execução das suas responsabilidades</h2>
      <p>
        Clique na estrela que representa a forma que você executou a
        responsabilidade indicada durante os últimos doze meses.
      </p>
      <p>
        Ao utilizar o <span class="info--text">"Não executou"</span>
        você está indicando que a responsabilidade é sua, porém não a executou
        nos últimos 12 meses.
      </p>
      <p>
        Atenção! As responsabilidades delegadas à sua equipe continuam sob
        sua competência, ou seja, o que for executado por sua equipe,
        indiretamente, foi executado por você.
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <p class="info--text">
        Lembre-se! Essa autoavaliação ajudará a direcionar sua trilha de
        desenvolvimento.
      </p>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialAutoavaliacaoResponsabilidade',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Responsabilidades', 'Execução das responsabilidades', 'Importante'],
    };
  },
};
</script>
